export default {
    'shoppingNote.title': '購物須知',
} as Record<string, string>;
